<template>
  <div class="u-color-primary">
    <template v-if="question.description">
      {{ question.description }}
    </template>
    <template v-else>
      Laden Sie das Dokument doch gleich hier hoch in Ihren Roodie.Safe.
    </template>
  </div>
  <div class="ion-margin-vertical">
    <file-input ref="fileInput" allowMultiple />
  </div>
  <div class="ion-text-center">
    <div>oder</div>
    <ion-button
      fill="outline"
      class="ion-margin-top"
      @click="openBefundeAuswahlModal()"
    >
      <ion-icon
        color="primary"
        :icon="documentAttachOutline"
        slot="start"
      ></ion-icon>
      Dokument aus Befunde & Co auswählen
    </ion-button>
    <div v-if="userFiles.length + partnerFiles.length">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col size="auto">
          {{ userFiles.length + partnerFiles.length }} ausgewählt
        </ion-col>
        <ion-col size="auto">
          <ion-button
            fill="clear"
            size="small"
            @click="
              userFiles = [];
              partnerFiles = [];
            "
            ><ion-icon slot="icon-only" :icon="trashOutline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
  <next-question-button @click="emitValues()" />
  <ion-modal
    :is-open="showError"
    :css-class="['c-autoheight-modal']"
    @didDismiss="showError = false"
  >
    <ion-page>
      <div class="ion-padding modal-content ion-text-center">
        <modal-close />
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <h6>
          {{ question.errorMessage }}
        </h6>
        <div class="ion-margin-top">
          <ion-button @click="showError = false">Ja</ion-button>
          <ion-button
            @click="
              showError = false;
              emitValues(true);
            "
            >Nein</ion-button
          >
        </div>
      </div>
    </ion-page>
  </ion-modal>
</template>

<script>
import {
  IonModal,
  IonPage,
  IonButton,
  IonIcon,
  modalController,
  IonRow,
  IonCol,
} from "@ionic/vue";
import Roodie from "../svg/Roodie";
import ModalClose from "../ModalClose";
import NextQuestionButton from "./NextQuestionButton";
import FileInput from "@arag/components/FileInput";
import { documentAttachOutline, trashOutline } from "ionicons/icons";
import BefundeAuswahlModal from "@arag/components/BefundeAuswahlModal";

export default {
  emits: ["done"],
  props: {
    question: {
      required: true,
      type: Object,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: null,
    },
  },
  components: {
    IonModal,
    IonPage,
    Roodie,
    ModalClose,
    NextQuestionButton,
    IonButton,
    FileInput,
    IonIcon,
    IonRow,
    IonCol,
  },
  setup() {
    return { documentAttachOutline, trashOutline };
  },
  data() {
    return {
      myFiles: [],
      showError: false,
      fileNumber: 1,
      userFiles: [],
      partnerFiles: [],
    };
  },
  methods: {
    async openBefundeAuswahlModal() {
      const modal = await modalController.create({
        component: BefundeAuswahlModal,
        componentProps: {
          userFiles: this.userFiles,
          partnerFiles: this.partnerFiles,
        },
      });
      modal.onDidDismiss().then((result) => {
        if (result.data?.userFiles) {
          this.userFiles = result.data.userFiles;
        }
        if (result.data?.partnerFiles) {
          this.partnerFiles = result.data.partnerFiles;
        }
      });
      return modal.present();
    },
    handleFileRenameFunction(file) {
      console.log(file);
      let fileName = "";
      if (file.extension === ".pdf") {
        fileName = file.name;
      } else {
        fileName = `behandlungsplan-${this.fileNumber}${file.extension}`;
        this.fileNumber = this.fileNumber + 1;
      }
      return fileName;
    },
    emitValues(force = false) {
      // let pondFile = null;
      const pondFiles = this.$refs.fileInput.$refs.pond.getFiles();
      const files = [];
      const fileNames = [];
      let statusError = false;
      for (const pondFile of pondFiles) {
        if (pondFile.status !== 2) {
          statusError = true;
        } else {
          files.push(pondFile.file);
          fileNames.push(pondFile.file.name);
        }
      }
      const selectedFilesLength =
        this.userFiles.length + this.partnerFiles.length;
      if (selectedFilesLength) {
        fileNames.push(`${selectedFilesLength} aus Befunde & Co`);
      }
      if (
        !force &&
        ((!files.length && !selectedFilesLength) ||
          // && this.selectedCondition.name === "toothTreatmentplan"
          statusError)
      ) {
        this.showError = true;
      } else {
        const emitValue = {
          value: fileNames.length ? fileNames.join(", ") : "Keine Angabe",
          id: this.question.id,
        };
        if (files.length) {
          emitValue.files = files;
        }
        if (this.userFiles.length) {
          emitValue.userFiles = this.userFiles;
        }
        if (this.partnerFiles.length) {
          emitValue.partnerFiles = this.partnerFiles;
        }
        this.$emit("done", emitValue);
      }
    },
  },
};
</script>

<style lang="scss">
.c-upload {
  .filepond--root {
    font-size: 1.4rem;
  }
  .filepond--credits {
    display: none;
  }
}
</style>
